module.exports = __webpack_public_path__ + "img/add-square.fa3be5fb.svg";